import styled from '@emotion/styled';
export const OurBenefitsStyles = styled.div`
    .headerUnderline {
        border-top: 3px solid #c8102e;
        position: absolute;
        margin-top: 0.25rem;
        width: 100%;
    }
`;
